import React from "react";

import { Warn } from "@churchofjesuschrist/eden-alert";
import { Ghost, Secondary } from "@churchofjesuschrist/eden-buttons";
import { Row } from "@churchofjesuschrist/eden-row";
import { Stack } from "@churchofjesuschrist/eden-stack";
import { yellow30 as alertColor } from "@churchofjesuschrist/eden-style-constants";
import styled from "styled-components";

import useManagedStrings from "../../utils/use-managed-strings";


const Header = styled.h3`
  margin: 0;
  padding: 0;
`;
//TODO: we don't have support in our eden library yet for the color on those gradients
//but I don't want to style it manually unless I absolutely have to.
//TODO: if we get theme support we would get rid of this style.
const Logout = styled(Ghost)`
  color: ${alertColor};
  &:hover {
    color: ${alertColor};
  }
`;

const stringGroups = [
  {
    name: "shared",
    keys: ["unsaved", "unsavedMessage", "continue", "cancel"],
  },
];

const UnsavedChangesConfirm = ({
  onConfirm = () => {},
  onCancel = () => {},
}) => {
  const {managedStrings:useStrings} = useManagedStrings(stringGroups);
  return (
    <Warn data-id="unsaved-confirm">
      <Stack>
        <Header>{useStrings.unsaved}</Header>
        <span>{useStrings.unsavedMessage}</span>

        <Row>
          <Secondary
            data-id="button-confirm"
            theme={{ primaryColor: alertColor }}
            onClick={onConfirm}
          >
            {useStrings.continue}
          </Secondary>
          <Logout
            data-id="button-logout"
            onClick={onCancel}
            theme={{ primaryColor: alertColor }}
          >
            {useStrings.cancel}
          </Logout>
        </Row>
      </Stack>
    </Warn>
  );
};

export default UnsavedChangesConfirm;
